import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrokerComponent } from './broker.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';



@NgModule({
  declarations: [
    BrokerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    MatRadioModule
  ], exports: [
    BrokerComponent
  ]
})
export class BrokerModule { }
